__webpack_require__.p = "/mykonyayeni/_next/";